module.exports = __webpack_public_path__ + "img/3.ca34d7fe.png";